import React, { useState } from 'react';
import { Button, Message } from '@getro/rombo';
import { Mail } from 'lucide-react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Box, Text } from 'rebass/styled-components';

import { SocialOAuthButtons } from '../../../../components/molecules/socialOAuthButtons';
import { openChat } from '../../../../helpers/supportChat';

export const SignUp = ({ routePath, sharedList }) => {
  const [oAuthError, setOAuthError] = useState(null);
  const history = useHistory();

  const onClickGoToProfile = (user) => {
    setOAuthError(null);

    if (user.onboardingCompleted) {
      history.push(`/shared-company-lists/${sharedList.slug}/install-extension`);
    } else {
      history.push(`/shared-company-lists/${sharedList.slug}/user/profile`);
    }
  };

  const onClickGoToSignIn = () => history.push(`${routePath}/sign-in`);

  return (
    <Box pb={['60px', '60px', '0']}>
      <Text fontSize="22px" fontWeight="semibold" color="text.dark">
        Find who you know at these companies
      </Text>
      <Text mt="16px" mb="32px">
        Connect your LinkedIn to easily find warm intros and offer help.
      </Text>
      <Box>
        <SocialOAuthButtons
          mode="sign-up"
          params={{ role: 'ally', collectionId: sharedList.collection?.id, sharedListId: sharedList.id }}
          onSuccess={onClickGoToProfile}
          onError={(e) => {
            setOAuthError(e);
          }}
        />
        <Button
          mt="8px"
          icon={Mail}
          variant="secondary"
          width="100%"
          sx={{ gap: '16px', justifyContent: 'center' }}
          onClick={onClickGoToProfile}
        >
          Continue with email
        </Button>
        {!!oAuthError && (
          <Message
            mt="8px"
            type="error"
            content={
              oAuthError?.status === 401 ? (
                oAuthError.data?.error
              ) : (
                <Text>
                  There was an unexpected error, please try again or{' '}
                  <Text as="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openChat}>
                    contact us
                  </Text>
                  .
                </Text>
              )
            }
          />
        )}
      </Box>
      <Box sx={{ position: 'absolute', bottom: '24px', left: '0', right: '0' }}>
        <Text as="p" fontSize="14px" width="100%" color="text.subtle" sx={{ textAlign: 'center' }}>
          Already a Getro user?{' '}
          <Text as="span" sx={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={onClickGoToSignIn}>
            Log in
          </Text>
        </Text>
      </Box>
    </Box>
  );
};

SignUp.propTypes = {
  routePath: PropTypes.string.isRequired,
  sharedList: PropTypes.object.isRequired,
};
